import Vue from "vue";
import Component from "vue-class-component";
import ABaseComponent from 'Components/Base/ABaseComponent';
import { Prop } from "vue-property-decorator";


@Component({
    template: "#download-information-modal-template"
})
export default class DownloadInformationModalComponent extends ABaseComponent{
    @Prop()
    public modalId: string;
 
}
Vue.component('download-info-modal', DownloadInformationModalComponent); 